import { createAction } from "redux-actions";
import {
  SHOW_FILTER_OVERLAY,
  HIDE_FILTER_OVERLAY,
  UPDATE_VIEWPORT_CATEGORY,
  UPDATE_CLIENT_WIDTH,
  HIDE_SORT_OVERLAY,
  SHOW_SORT_OVERLAY,
  SHOW_SUCCESS_MESSAGE,
  HIDE_SUCCESS_MESSAGE,
  TOGGLE_SECONDARY_LIST,
  SET_DETECTED_FLOOR
} from "./constants";
import { analyticsOpenFilterSmall } from "../analytics/actions";
import { setViewportCategoryCookie } from "./columnCount";

export const toggleSecondaryList = createAction(TOGGLE_SECONDARY_LIST);
export function showFilterOverlay() {
  return dispatch => {
    dispatch(createAction(SHOW_FILTER_OVERLAY)());
    dispatch(analyticsOpenFilterSmall());
  };
}

export function showSortOverlay() {
  return dispatch => {
    dispatch(createAction(SHOW_SORT_OVERLAY)());
  };
}

export const hideFilterOverlay = () => ({
  type: HIDE_FILTER_OVERLAY
});

export const hideSortOverlay = () => ({
  type: HIDE_SORT_OVERLAY
});

export const updateViewportCategory = viewportCategory => {
  setViewportCategoryCookie(viewportCategory);

  return {
    type: UPDATE_VIEWPORT_CATEGORY,
    payload: {
      viewportCategory
    }
  };
};

export const updateClientWidth = clientWidth => ({
  type: UPDATE_CLIENT_WIDTH,
  payload: {
    clientWidth
  }
});

export const showSuccessMessage = ({ linkText, linkUrl, message }) => ({
  type: SHOW_SUCCESS_MESSAGE,
  payload: {
    linkText,
    linkUrl,
    message
  }
});

export const hideSuccessMessage = () => ({ type: HIDE_SUCCESS_MESSAGE });

export const setDetectedFloor = createAction(SET_DETECTED_FLOOR);
